import {DONATION_PLEDGES} from '../../Constants/database';
import firestore from '../../Firebase/firestore';

export const getUserDonationPledges = (userId: string) => {
  return firestore()
    .collection(DONATION_PLEDGES)
    .where('payerId', '==', userId)
    .orderBy('createdAt', 'desc');
};
